import { EMPTY_NUMBER_ID } from '@/constant/common'

import { DTO } from '../DTO'

export class LessonClassDetail extends DTO {
  id = EMPTY_NUMBER_ID
  name = ''
  grade = 1
  index = 1
  teacherIdList: string[] = []
  studentIdList: string[] = []

  constructor(data: Partial<res.LessonClassDetail> = {}) {
    super()
    this.update<LessonClassDetail>(this, data)
  }
}
